// eslint-disable-next-line no-unused-vars
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

class UndrawNoDataAlt extends PureComponent {
    render = () => {
        return (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 836.27 674.21"
                {...this.props}
            >
                <circle cx="123" cy="428" r="123" fill="#f2f2f2" />
                <circle cx="143" cy="410" r="123" fill="#337ab7" />
                <path fill="#f2f2f2" d="M58 72h108v108H58z" />
                <path fill="#337ab7" d="M73 56h108v108H73z" />
                <path
                    fill="#3f3d56"
                    d="M171.86 664.68h158.41v1.87H171.86zM234 142H92V0h142zm-140-2h138V2H94z"
                />
                <path fill="#f2f2f2" d="M301 275h28v28h-28z" />
                <path fill="#337ab7" d="M307 268h28v28h-28z" />
                <path
                    d="M362 286h-46v-46h46zm-44-2h42v-42h-42zM251 667c-84.36 0-153-68.64-153-153s68.64-153 153-153 153 68.64 153 153-68.64 153-153 153zm0-304c-83.26 0-151 67.74-151 151s67.74 151 151 151 151-67.74 151-151-67.74-151-151-151zM528.86 669.68h158.41v1.87H528.86zM677.86 499.68h158.41v1.87H677.86z"
                    fill="#3f3d56"
                />
                <path
                    d="M627.31 58.46c-30.18 8.18-47.29 41.96-38.22 75.45l11.53 42.56 13.1-3.55 3.3-17.82 2.37 16.28 84.13-22.78 3-16.2 2.16 14.8 9.48-2.57-9.06-33.41c-10.44-38.55-47.06-62.17-81.79-52.76z"
                    fill="#2f2e41"
                />
                <path
                    d="M565.5 579.5l13 46-2 17 38-8s-16-27-14-41zM737.5 414.5l-10 54 33-5L762 407l-24.5 7.5z"
                    fill="#ffb8b8"
                />
                <circle cx="638.5" cy="118.5" r="36" fill="#ffb8b8" />
                <path
                    fill="#ffb8b8"
                    d="M627 145l-2 20-16 9 42 93 32-77-21-16-2-38-33 9z"
                />
                <path
                    d="M656.5 244.5l-40.96-74.18s-33.04 2.18-41.04 9.18l16 102-5 13s-41 42-33 133 8 162 8 162 29 34 89 0v-181l85-7v22s88-22 90-55l-22.64-39.32A38.94 38.94 0 00757 311.3l-74.5 22.21-8-30 8-22s21-16 21-37 6-46 6-46l-38.9-17.95z"
                    fill="#2f2e41"
                />
                <path
                    d="M727.5 236.5l16 39s17 20 20 42l5 26s12 46-7 44-14-46-14-46l-3-13-17-28-25.08-47.68z"
                    fill="#ffb8b8"
                />
                <path
                    d="M730.5 459.5s28.61 2.8 34.3-10.1l28.7 23.1s51.97 13.92 23 26c-27 11.26-54-.76-54 2 0 0-8-7-17-2s-36 0-35-8 5-37 20-31zM577.5 630.5s28.61 2.8 34.3-10.1l28.7 23.1s52.17 14.4 23 26c-26.97 10.72-53.99-.6-54 2 0 0-8-7-17-2s-36 0-35-8 5-37 20-31zM696.5 194.5l13 4 28 42-51 34 10-80zM647.38 70.96c-7.4-5.58-16.71-7.86-25.74-5.41l-1.08.29c-20.68 5.6-32.38 28.86-26.13 51.95l6.93-1.87-1.19-8.83 3.95 8.08 41.11-11.14 1.5-8.14 1.09 7.44 8.09-2.19q13.27 26.58-1.04 60.63l13.78-3.73 2.98-16.28 2.18 14.88 26.26-7.11-3.81-34.56c-6.73-24.83-26.86-41.98-48.88-44z"
                    fill="#2f2e41"
                />
                <circle cx="656" cy="49" r="18" fill="#2f2e41" />
                <path
                    d="M655 59a17.99 17.99 0 01-6.33-34.83 17.99 17.99 0 108.66 34.66A18.07 18.07 0 01655 59z"
                    fill="#2f2e41"
                />
                <ellipse
                    cx="661.5"
                    cy="118.5"
                    rx="4.5"
                    ry="6.5"
                    fill="#ffb8b8"
                />
                <path
                    d="M575 469c-24.75-3.68-54.74-2.83-87 0q20.17-36.99 0-65a360.89 360.89 0 0087 0c-12.39 20.63-11.3 42.38 0 65z"
                    fill="#337ab7"
                />
                <path
                    d="M563.5 239.5l-3 40s-14 22-17 69l-1 29s-21 41-4 40 16-39 16-39l30-87v-42z"
                    fill="#ffb8b8"
                />
                <path
                    d="M581.5 180.5h-7s-11 7-20 37-10 31-10 31l47 11z"
                    fill="#2f2e41"
                />
                <path fill="#d0cde1" d="M518 424h28v28h-28z" />
            </svg>
        );
    };
}

UndrawNoDataAlt.propTypes = {
    height: PropTypes.string,
    width: PropTypes.string
};

export default UndrawNoDataAlt;
